import web2clientapi from '@wg/web2clientapi';
import { t } from "../helpers/localization";
import { sendNotification } from "./base";
import { wrapInP } from "./formatting";


export const sendBuildSuccessNotification = data => {

  const header = t('Улучшение %(level)s из %(maxLevel)s построено', {
    level: data.level,
    maxLevel: data.maxLevel
  });

  sendNotification({
    hasHeader: true,
    header: data.title,
    message: wrapInP(`${header}&#13;`, data.message),
    cost: data.cost,
    currency: 'clan_resource'
  });
};

export const ClanBaseSoundObjectPos = data => {
  web2clientapi._sendCommand({
    command: 'ClanBaseSoundObjectPos',
    params: data
  });
};

export const ClanBaseCameraPos = position => {
  web2clientapi._sendCommand({
    command: 'ClanBaseCameraPos',
    params: position
  });
};